module.exports = __webpack_public_path__ + "img/cloth_g1_shoe_03.35ad3551.svg";